import {
  CAMPAIGN_METRICS,
  REP_STACK_METRICS,
  REP_TREND_METRICS,
  GATEWAY_METRICS,
} from '../componentKeys.js'

const identifiers = {
  key: 'salesPerCall',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Sales / Call',
  },
}

const keys = {
  componentKeys: [
    CAMPAIGN_METRICS,
    REP_STACK_METRICS,
    REP_TREND_METRICS,
    GATEWAY_METRICS,
  ],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'divide',
  dividend: { stat: 'qualified' },
  divisor: { stat: 'calls' },
  isRate: true,
}

const salesPerCall = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { salesPerCall }
